import asyncActionTypes from '../actions/types.js';

const initialState = {
  loading: false,
  travelInformation: {},
};

const travelInformation = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_CMS_TRAVEL_INFORMATION.START:
      return {
        ...state,
        loading: true,
      };
    case asyncActionTypes.RETRIEVE_CMS_TRAVEL_INFORMATION.SUCCESS:
      const menuInformation = Object.entries(action.payload).length !== 0 ? action.payload[0] : {};

      return {
        ...state,
        loading: false,
        travelInformation: menuInformation,
      };
    case asyncActionTypes.RETRIEVE_CMS_TRAVEL_INFORMATION.FAIL:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default travelInformation;
